export const TOUR_GUILD_HIDDEN = "TOUR_GUILD_HIDDEN";
export const TOUR_GUILD_SHOW = "TOUR_GUILD_SHOW";
